import { useState } from "react";
import { Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import GlobalDialogContent from "../../GlobalDialogContent";
import { showSnackbar } from "@/redux/reducer/snackbarSlice";
import { closeDialog } from "@/redux/reducer/dialogSlice";
import { setModuleRefresh } from "@/redux/reducer/registration/RefreshSlice";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { ThemeStatusUpdateService } from "@/utils/services/roles.permission.service";

const ThemeStatusUpdate = () => {
    const payload = useSelector((state: any) => state.dialog?.payload);
    const dispatch = useDispatch();
    const [remark, setRemark] = useState("");
    const [remarkTouched, setRemarkTouched] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const remarkError = remarkTouched && !remark.trim();

    const handleStatusUpdate = async (status: "approved" | "rejected") => {
        setRemarkTouched(true);
        if (!remark.trim()) return;

        setSubmitting(true);
        const reqPayload = {
            theme_id: payload?.id,
            action: "store",
            status,
            remark: remark.trim(),
        };
        const { code, message } = await ThemeStatusUpdateService(reqPayload);
        setSubmitting(false);
        if (code === 200) {
            dispatch(showSnackbar({ type: "success", message: message || "Status Updated Successfully." }));
            dispatch(closeDialog());
            dispatch(setModuleRefresh({ moduleName: "ThemeRefresh", refresh: true }));
        } else {
            dispatch(showSnackbar({ type: "error", message: message || "Something Went Wrong!" }));
        }
    };

    return (
        <GlobalDialogContent
            dialogBody={
                <TextField
                    fullWidth
                    label="Remark *"
                    size="small"
                    multiline
                    rows={3}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    onBlur={() => setRemarkTouched(true)}
                    placeholder="Enter Remark"
                    error={remarkError}
                    helperText={remarkError ? "Remark is Required" : ""}
                />
            }
            dialogFooter={
                <>
                    <Button
                        variant="contained"
                        color="error"
                        disabled={submitting}
                        startIcon={<HighlightOffIcon />}
                        onClick={() => handleStatusUpdate("rejected")}
                    >
                        Reject
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        disabled={submitting}
                        startIcon={<CheckCircleOutlineIcon />}
                        onClick={() => handleStatusUpdate("approved")}
                    >
                        Approve
                    </Button>
                </>
            }
        />
    );
};

export default ThemeStatusUpdate;
